import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRouter = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      rest.isAuthenticated === true
        ? <Component {...props} />
        : <Redirect to='/login' />
    )}
  />
);

export default PrivateRouter;
